export class StationColors {
    // static readonly BIKES_AVAILABLE = '#5677FC'; //Blue
    // static readonly POINTS_AVAILABLE = '#F5A623'; //Orange
    // static readonly BIKES_AND_POINTS_AVAILABLE = '#259B23'; //Green
    // static readonly DISABLED = '#E51C24'; //Red
    // static readonly FULL = '#484848'; //Dark Gray

    static readonly BIKES_AVAILABLE = 'rgba(0,0,0,1)';
    static readonly MINIMUM_BIKES = 'rgba(255,0,0,1)';
    static readonly IDEAL_BIKES = 'rgba(255,165,0,1)';
    static readonly AVAILABLE_BIKES = 'rgba(0,0,0,0.9)';
    static readonly AVAILABLE_WITH_ERRORS = 'rgba(245,166,35,0.9)';
    static readonly AVAILABLE_WITH_DISABLED = 'rgba(208,2,27,0.9)';
    static readonly GREY_BIKES = '#A9A9A9';
    static readonly DISABLED_WITHOUT_BIKES = 'rgba(154,154,154,1)';
    static readonly CHECKED_NEEDS_REPAIR_BIKES = '#6236BA';
}